module.exports = __webpack_public_path__ + "static/Winner seal__NSW_Broker of the Year-864e6c2e18b71ec643063ef4ee251cf7.png";